import script from "./Info.vue?vue&type=script&setup=true&lang=ts"
export * from "./Info.vue?vue&type=script&setup=true&lang=ts"

import "./Info.vue?vue&type=style&index=0&id=24eff7b0&lang=css"

const __exports__ = script;

export default __exports__